// TODO: get better way to do this, maybe move all constants to a new lib
// eslint-disable-next-line import/prefer-default-export
export const SALFA_RAC_EXT_BUSINESS_UNIT_ID = 33;
